import React from 'react';
import { Route, Switch, Redirect, useRouteMatch } from 'react-router';
import ConnectorViewProfile from './ConnectorViewProfile';
import ContentRoot from '../../../components/ContentRoot';

const ConnectorProfileHome = () => {
  const { path } = useRouteMatch();
  return (
    <ContentRoot>
      <Switch>
        <Route path={`${path}`} render={() => <ConnectorViewProfile />} />
        <Route render={() => (<Redirect to='/connector' />)} />
      </Switch>
    </ContentRoot>
  );
};

export default ConnectorProfileHome;

